export default __webpack_public_path__ + "static/media/submenu-mediacenter.2bca51b0.jpg";